import { ExclamationTriangleIcon, InformationCircleIcon } from '@heroicons/react/24/outline';
import { ReactNode } from 'react';
import type { InlineAlertTone } from './InlineAlertTone';

type InlineAlertProps = {
  tone?: InlineAlertTone;
  children: ReactNode;
  className?: string;
};

const TONE_CLASS: Record<InlineAlertTone, string> = {
  info: 'erp-alert-info',
  warning: 'erp-alert-warning',
};

export function InlineAlert({ tone = 'info', children, className = '' }: InlineAlertProps) {
  const Icon = tone === 'warning' ? ExclamationTriangleIcon : InformationCircleIcon;

  return (
    <div role="status" className={`flex items-start gap-3 ${TONE_CLASS[tone]} ${className}`.trim()}>
      <Icon className="mt-0.5 h-5 w-5 shrink-0" aria-hidden="true" />
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  );
}
